import {Avatar, Paper} from "@mui/material";
import {useNavigate} from "react-router-dom";

export default function BrandAvatarBox() {
  const navigate = useNavigate();

  return (
    <Paper
      onClick={() => {
        navigate("/");
      }}
      variant="feature"
      sx={{
        minWidth: "72px",
        maxWidth: "72px",
        width: "72px",
        p: "12px",
        boxSizing: "border-box",
        ":hover": {cursor: "pointer"},
      }}>
      <Avatar
        alt="Prep Genie"
        src={process.env.PUBLIC_URL + `/PrepGenieLogo.svg`}
        variant="square"
        sx={{
          width: "100%",
          height: "auto",
        }}
      />
    </Paper>
  );
}
